import { useQuery } from "@tanstack/react-query";
import { getProfitAndLossMonthlyGraph } from "@/services/profit-and-loss-monthly-graph-api";
import type { ProfitAndLossMonthlyGraphData } from "@/types/profit-and-loss-monthly-graph-api";

type YM = { year: number; month: number };
type RangeFilter = { from: YM; to: YM };

export function useProfitAndLossMonthlyGraphRange(
  clientId: string,
  connectionId: string,
  dateRange: RangeFilter,
  enabled: boolean
) {
  return useQuery({
    queryKey: ["pnl-monthly-graph-range", clientId, connectionId, dateRange],
    enabled,
    queryFn: async (): Promise<ProfitAndLossMonthlyGraphData> =>
      getProfitAndLossMonthlyGraph(
        clientId,
        [connectionId],
        dateRange.from.year,
        dateRange.from.month,
        dateRange.to.year,
        dateRange.to.month
      ),
  });
}
